export const card = "shadow-none py-4";
export const rowStyles ="flex items-start"
export const columnStyles="flex flex-col"
export const container = (flexDirection: 'row' | 'col') => `flex flex-${flexDirection} justify-between h-full`;
export const title = "text-lg font-semibold";
export const comment = "text-sm my-3 w-3/4";
export const button = "border border-gray-500 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-500 ml-auto";

export const backgroundImage = 'bg-cover bg-center';